import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=6d92bddb&scoped=true&"
import script from "./ChannelList.vue?vue&type=script&lang=ts&"
export * from "./ChannelList.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=6d92bddb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d92bddb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
